import type { ReactElement } from "react";

import { MADSTextInput, type MADSTextInputProps } from "../TextInput/TextInput";

export interface TextAreaProps extends Omit<
  MADSTextInputProps,
  "multiline" | "contentBefore" | "contentAfter" | "showClearButton" | "ariaClearTextDescription"
> {}

export function TextArea({
  ariaText = "Text Area",
  textAreaHeight = 164,
  ...props
}: TextAreaProps): ReactElement {
  return (
    <MADSTextInput
      ariaText={ariaText}
      multiline={true}
      textAreaHeight={textAreaHeight}
      {...props}
    />
  );
}
